/**
 * FAQs for /xerf-vs-morpheus8-thermage-ultherapy.
 *
 * One source for the visible FAQ and the FAQPage JSON-LD. Technology facts match what the XERF page
 * (client/src/pages/XerfSkinTightening.tsx) already prints: XERF is a needle-free, multifrequency monopolar RF
 * device (6.78 MHz and 2 MHz) from Cynosure Lutronic, introductory pricing $1,250 / $3,200, usually 1-2 sessions
 * about 4 weeks apart. Lakewood does NOT offer Morpheus8, Thermage or Ultherapy and the copy never implies it does.
 * No superiority or percentage-result claims.
 */
export type CompareFaq = { q: string; a: string };

export const SKIN_TIGHTENING_COMPARE_FAQS: CompareFaq[] = [
  {
    q: "XERF vs Morpheus8: which is better?",
    a: "Neither is better for everyone, because they do different jobs. XERF is a needle-free radiofrequency treatment for early looseness of the face, jawline and neck. Morpheus8 is a branded RF microneedling device, which makes it a better match for texture and acne scars. Lakewood does not offer Morpheus8; Dr. Kohli offers XERF and a different RF microneedling device.",
  },
  {
    q: "XERF vs Thermage: what is the difference?",
    a: "Both are needle-free monopolar radiofrequency treatments, so they belong to the same technology class. XERF is a multifrequency system that combines 6.78 MHz and 2 MHz energy. Lakewood does not offer Thermage and does not claim XERF outperforms it; Dr. Kohli explains what XERF can reasonably do for your skin at a consultation.",
  },
  {
    q: "XERF vs Ultherapy: which one tightens skin better?",
    a: "They work by different mechanisms, so one is not simply stronger than the other. XERF uses radiofrequency heat, while Ultherapy uses micro-focused ultrasound. Lakewood does not offer Ultherapy; it offers XERF for radiofrequency and HIFU for focused ultrasound, and Dr. Kohli recommends whichever mechanism suits your anatomy, or tells you neither does.",
  },
  {
    q: "Which is the better match for acne scars and rough texture?",
    a: "RF microneedling is the better match, because microneedles deliver radiofrequency into the skin to remodel texture and scars. XERF is not a scar treatment. Lakewood offers RF microneedling, fractional CO₂ and DuoVive for scars, and Dr. Kohli chooses based on your scar type and skin tone.",
  },
  {
    q: "How much does XERF cost in Dallas?",
    a: "Introductory XERF pricing at Lakewood Med Spa is $1,250 for one session or $3,200 for a series of three. The consultation is complimentary, and your treatment area and session count are decided individually. Other clinics set their own prices, so compare the total plan rather than a single session.",
  },
  {
    q: "Do you offer Morpheus8, Thermage or Ultherapy?",
    a: "No. We name them because patients search for them and deserve a straight comparison. Lakewood Med Spa offers XERF, HIFU and RF microneedling, and Dr. Rajan Kohli, MD will tell you which fits your skin, or that another option or a surgical opinion would serve you better.",
  },
];
